import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Form } from "reactstrap";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { styled } from '@material-ui/core/styles';

import { DatePicker, Space, ConfigProvider } from 'antd';
import "dayjs/plugin/updateLocale";
import "dayjs/locale/ko";
import locale from 'antd/locale/ko_KR';
import HomeIcon from '@material-ui/icons/Home';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../Shared/Css/Purchases/Purchas.module.css';
import GesansuLoading from './GesansuLoading';

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea'
  },
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green",
    color: "red",
  },

});

function GesansuList() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료
  //const gridRef = useRef();
  const [gesansuList, setGesansuList] = useState([]); //데이터 가저오기
  const [gongjang, setGongjang] = useState(); //공장선택(정진,제이콥)
  const [customer, setCustomer] = useState([]); // 업체selectPicker 데이터 가저오기
  const [valueSelectPicker, setValueSelectPicker] = useState(''); //selectPicker 데이터 가저오기
  const [startDate, setStartDate] = useState(''); //월마감검색시작날짜
  const [endDate, setEndDate] = useState(''); //월마감검색끝날날짜
  const [startDayDate, setStartDayDate] = useState(''); //일검색시작날짜
  const [endDayDate, setEndDayDate] = useState(''); //일검색시작날짜
  const [groupby, setGroupby] = useState(); //집계방법(개별,그롭)
  const [gesansuListNameChange, setGesansuListNameChange] = useState(''); //검색클릭값전달
  const [loading, setLoading] = useState(false)

  //히스토리사용
  const history = useHistory();

  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    if (pwloading !== urlpw) {
      // window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login');
    }
  }, [pwloading, urlpw])
  //------------------------------------------------------세션복고화끝

  useEffect(() => {
    GetSelectCustomer();
  }, []);

  //업체찾기
  const GetSelectCustomer = async () => {
    await axios.get("/InvoiceReact/UpcheMasterIndex")
      .then((res) => {
        setCustomer(res.data)
      })
  };
  //new Grid option 설정부분
  const columns = (
    [
      { name: "id", header: "ID", align: "center", width: 60 },
      { name: "upche_taxbill", header: "세금계산서", align: "center", width: 100 },
      { name: "invoice_factory", header: "세금계산서", align: "center", width: 80 },
      { name: "invoice_ma_gam_dal", header: "마감달", align: "center", width: 75 },
      // { name: "invoices_u_mu_yn", header: "출고유무", align: "center", width: 80 },
      {
        name: "invoices_upche", header: "업체", align: "left", width: 150,
        filter: { type: 'text', code: 'Contains', value: 30, showClearBtn: true }
      },
      { name: "invoices_item", header: "우리품번", align: "center", width: 66 },
      {
        name: "invoices_upche_item", header: "업체품번", align: "left", width: 150,
        filter: { type: 'text', code: 'Contains', value: 30, showClearBtn: true }, className: 'gross-color',
      },
      { name: "invoices_upche_name", header: "품명", align: "left", width: 180 },
      { name: "invoices_price_pimac", header: "P단가", align: "right", width: 50 },
      { name: "invoices_danwi", header: "P단위", align: "center", width: 50 },
      { name: "invoices_price_dopo", header: "D단가", align: "right", width: 50 },
      { name: "invoice_dopo_danwi", header: "D단위", align: "center", width: 50 },
      { name: "invoices_price", header: "S단가", align: "right", width: 50 },
      {
        name: "invoices_quantity", header: "출고수량", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_피막금액", header: "피막금액", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_도포금액", header: "도포금액", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_출고금액", header: "공급가액", align: "right", width: 110, className: 'gross-color1',
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_부가세", header: "세액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_합계금액", header: "계산서금액", align: "right", width: 110, className: 'gross-color2',
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_datetime", header: "출고일자", align: "center", width: 115,
        formatter: function (ev) {
          return `${dayjs(ev.value).format('YYYYMMDD HH:mm')}`
        }
      },
    ]
  );

  // //번호, 체크박스 설정부분
  const rowHeaders = [
    { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = gesansuList.map((row) => ({
    id: row.id,
    upche_taxbill: row.upche_taxbill,
    invoice_factory: row.invoice_factory,
    invoice_ma_gam_dal: row.invoice_ma_gam_dal,
    invoices_upche: row.invoices_upche,
    invoices_item: row.invoices_item,

    invoices_upche_item: row.item_pal085s
      ? `${row.invoices_upche_item || ''} [${row.item_pal085s}]` : row.invoices_upche_item,
    invoices_upche_name: row.invoices_upche_name,
    invoices_price_pimac: row.invoices_price_pimac,
    invoices_danwi: row.invoices_danwi,
    invoices_price_dopo: row.invoices_price_dopo,
    invoice_dopo_danwi: row.invoice_dopo_danwi,
    invoices_price: row.invoices_price,
    invoices_quantity: row.invoices_quantity,
    invoices_피막금액: Number(row.invoices_피막금액),
    invoices_도포금액: Number(row.invoices_도포금액),
    invoices_출고금액: Number(row.invoices_출고금액),
    invoices_부가세: Number(row.invoices_부가세),
    invoices_합계금액: Number(row.invoices_출고금액) + Number(row.invoices_부가세),
    invoices_datetime: row.invoices_datetime
  }));
  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: 'Count',
        name: 'Count',
        childNames: ['Iid']
      },
      {
        header: '홈텍스',
        name: '홈텍스',
        childNames: ['upche_taxbill']
      },
      {
        header: '거래명세표',
        name: '거래명세표',
        childNames: ['invoice_factory']
      },
      {
        header: '피막',
        name: '피막',
        childNames: ['invoices_price_pimac', 'invoices_danwi']
      },
      {
        header: '도포',
        name: '도포',
        childNames: ['invoices_price_dopo', 'invoice_dopo_danwi']
      },
      {
        header: '세금계선서',
        name: '세금계선서',
        childNames: ['invoices_출고금액', 'invoices_부가세', 'invoices_합계금액']
      },
    ]
  }

  //그리드 합계부분
  const summary = {
    height: 30,
    position: 'bottom', // or 'top'
    columnContent: {
      invoice_factory: {
        template(summary) {
          return '<div align="center"><b>합계</b></div>';
        }
      },
      invoices_quantity: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`; //Math.floor(summary.sum) 소솟점 버리기
        }
      },
      invoices_피막금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_도포금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_출고금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_부가세: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_합계금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}<b/></div>`;
        }
      },
    },
  };

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      // border: 'pink',
      border: '#42a5f5',
    },
    outline: {
      // border: 'blue',
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: '#C0C0C0',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //selectPicker 업체 데이타뿌리기
  const selectData = customer.map(
    item => ({ label: item.upche_sanghoupche_sangho, value: item.upche_code })
  );

  //검색클릭 값변경
  const handleGesansuListNameChange = (e) => {
    e.preventDefault();
    setGesansuListNameChange((e.target.value).toUpperCase());
  };

  //검색엔트
  const handleGesansuListNameEnter = (e) => {
    e.preventDefault();
    if (gesansuListNameChange !== '' && e.key === 'Enter') {
      refreshGesansuList(); // null이 아니면 실행됨
    }
    else {
      // setGesansuList([]);
    }
  };

  //조회버튼
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      공장구분: gongjang ? gongjang : null,
      업체코드: valueSelectPicker.value ? valueSelectPicker.value : null,
      우리품번: evValue.get("ulisabun") ? evValue.get("ulisabun") : null,
      업체품번: evValue.get("cusitem") ? evValue.get("cusitem") : null,
      월마감시작: startDate ? startDate : null,   //월마감시작
      월마감종료: endDate ? endDate : null,   //월마감종료
      월마감시작일자: startDayDate ? startDayDate : null,   //월일마감시작일자
      월마감종료일자: endDayDate ? endDayDate : null,   //월일마감종료일자
      합계선택: groupby ? groupby : '',   //합계선택 ,개별,그룹,품번
    }
    // console.log(DataSerche)

    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/Gesansu/Gasansu01'
    axios.get(urlButtonSerche, {
      params: {
        GesansuGojang: DataSerche.공장구분,
        GesansuUpcheCode: DataSerche.업체코드,
        GesansuUliItem: DataSerche.우리품번,
        GesansuCusItem: DataSerche.업체품번,
        GesansuStartDate: DataSerche.월마감시작,
        GesansuEndDate: DataSerche.월마감종료,
        GesansuStartDayDate: DataSerche.월마감시작일자,
        GesansuEndDayDate: DataSerche.월마감종료일자,
        GesansuGroup: DataSerche.합계선택
      }
    })
      .then((res) => {
        setGesansuList(res.data);
        // console.log(res.data)
      })
      .finally(function () {
        //항상실행됨
        setLoading(false)
      })
  };

  // console.log(gesansuList)

  //마감날짜범위등록시작일
  const onDateStartChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setStartDate(dateStrings)
    } else {
      setStartDate()
    }
  };
  //마감날짜범위등록종료일
  const onDateEndChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setEndDate(dateStrings)
    } else {
      setEndDate()
    }
  };
  //월마감시작일자
  const onDayDateStartChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setStartDayDate(dateStrings)
    } else {
      setStartDayDate()
    }
  };
  //월마감종료일자
  const onDayDateEndChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setEndDayDate(dateStrings)
    } else {
      setEndDayDate()
    }
  };
  //공장선택
  let gongjangHandle = (e) => {
    e.preventDefault();
    setGongjang(e.target.value);
  }
  //공장선택
  let groupbyHandle = (e) => {
    e.preventDefault();
    setGroupby(e.target.value);
  }

  const gesansuAPI = useCallback(() => {
    const url = '/api/Gesansu/';
    return {
      fetchAll: () => axios.get(url, { params: { GesansuSercheName: gesansuListNameChange, GesansuStartDate: startDate, GesansuEndDate: endDate } }),
    };
  }, [endDate, gesansuListNameChange, startDate]);

  const refreshGesansuList = useCallback(async () => {
    await gesansuAPI()
      .fetchAll()
      .then((res) => {
        setGesansuList(res.data);
      })
      .catch((err) => console.log(err));
  }, [gesansuAPI]);


  return (
    <>
      {loading ? <GesansuLoading /> : null}
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ paddingBottom: "10px", marginTop: "20px", textAlign: "center", color: "blue" }}>세금계산서[홈택스]</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleSubmit} style={{ marginBottom: "10px" }}>
            <div className="input-group mb-12">
              <FormControl variant="outlined" style={{ minWidth: 150, marginRight: '2px' }} size="small">
                <InputLabel >공장</InputLabel>
                <CssSelect
                  variant="outlined"
                  value={gongjang ? gongjang : ''}
                  onChange={gongjangHandle}
                  label="공장"
                >
                  <MenuItem value=''><em>선택없음</em></MenuItem>
                  <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                  <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                </CssSelect>
              </FormControl>
              <Autocomplete
                size="small"
                style={{ width: 200, marginRight: 3 }}
                options={selectData || []} // 데이터가 없을 때를 대비해 빈 배열 처리
                getOptionLabel={(option) => option.label || ""}
                getOptionSelected={(option, value) => {
                  if (!value || value.value === "") return true;
                  return option.value === value.value;
                }}
                value={valueSelectPicker && valueSelectPicker.value !== "" ? valueSelectPicker : null}
                onChange={(event, newValue) => {
                  setValueSelectPicker(newValue || { label: '', value: '' });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="업체" variant="outlined" />
                )}
              />
              <TextField
                style={{ width: 130, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="우리품번"
                name="ulisabun"
                autoComplete="ulisabun"
              />
              <TextField
                style={{ width: 130, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="업체품번"
                name="cusitem"
                autoComplete="cusitem"
              />
              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    //autoFocus
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    picker="month"
                    format="YYYYMM"
                    placeholder="시작마감월"
                    onChange={onDateStartChangeHandle} //날짜범위시작일
                  />
                </Space>
              </ConfigProvider>
              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    picker="month"
                    format="YYYYMM"
                    placeholder="종료마감월"
                    onChange={onDateEndChangeHandle} //날짜범위종료일
                  />
                </Space>
              </ConfigProvider>
              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    autoFocus
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="출하시작일자"
                    onChange={onDayDateStartChangeHandle} //날짜범위시작일
                  />
                </Space>
              </ConfigProvider>
              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="출하종료일자"
                    onChange={onDayDateEndChangeHandle} //날짜범위시작일
                  />
                </Space>
              </ConfigProvider>
              {/* 집계방법 */}
              <FormControl variant="outlined" style={{ minWidth: 120, marginRight: '4px' }} size="small">
                <InputLabel >집계방법</InputLabel>
                <Select
                  variant="outlined"
                  value={groupby ? groupby : ''}
                  onChange={groupbyHandle}
                  label="집계방법"
                >
                  <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                  <MenuItem value={'개별'}>개별</MenuItem>
                  <MenuItem value={'품번'}>품번</MenuItem>
                  <MenuItem value={'업체'}>업체</MenuItem>
                  <MenuItem value={'공장'}>공장</MenuItem>
                </Select>
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 120,
                  marginRight: 3,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40', color: 'white', height: 36, width: 120, float: "center",
                }}
                onClick={() => {
                  // window.location.href = "/home/index";
                  history.goBack();
                }}
              >
                홈이동
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="materialInputNameChange"
          value={gesansuListNameChange}
          onChange={handleGesansuListNameChange}
          onKeyUp={handleGesansuListNameEnter}
          onClick={() => {
            if (gesansuListNameChange !== '') {
              setGesansuListNameChange('');
            }
          }}
        />
      </div>
      <Container maxWidth="xl" style={{ padding: '0px 20px 0px 20px' }}>
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            summary={summary}
            //scrollX={false}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={30}
            bodyHeight={560}
            // bodyHeight={"auto"}
            heightResizable={true}
            //rowHeaders={['rowNum','checkbox']}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false} //전 세계적으로 TOAST UI Grid가 얼마나 널리 사용되고 있는지 파악 사용
            pageOptions={{ useClient: true, perPage: 18 }} // front에서만 페이징 하는 속성
            //oneTimeBindingProps={['data', 'columns']} //무조건 재랜더링 방지
            columnOptions={{
              minWidth: 50,
              resizable: true,  //걸럼마우스조절가능
              frozenCount: 3,  //고정컬럼숫자선택
              frozenBorderWidth: 1,
            }}
          />
        </Box>
      </Container>
    </>
  )
}
export default GesansuList